import Model from './Model';

export default class FileAction extends Model {
    code;
    name;

    static apiPath() {
        return 'trajectory-file-actions';
    }
}



// WEBPACK FOOTER //
// ./src/models/FileAction.js